if(!customElements.get('featured-items')) {

  class ComponentFeaturedItems extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.slidesWrapper = this.querySelector('.keen-slider');
      this.dots = this.querySelector('.keen-dots');
      this.prevButton = this.querySelector('.keen-arrow.prev');
      this.nextButton = this.querySelector('.keen-arrow.next');
      this.slides = this.slidesWrapper.children;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;
      this.effect = this.dataset.effect;
      this.mode = this.dataset.mode;
      this.loop = this.dataset.loop;
      this.autoplay = this.dataset.autoplay;
      this.pauseOnHover = this.dataset.pauseOnHover!=='false';
      this.spacing = this.dataset.spacing;
      this.carousel = false;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initCarousel();
      }, 1);

      this.bindCustomizerEvents();
    }

    initCarousel() {
      if(this.slides.length > 1) {
        this.carousel = new KeenSlider(this.slidesWrapper, {  
          mode: this.mode,
          loop: this.loop,
          wheel: false,
          dots: this.dots,
          prevButton: this.prevButton,
          nextButton: this.nextButton,
          customAnimation: this.effect=='fade' ? 'fade' : false,
          setContainerHeight: this.effect=='fade',
          autoplay: this.autoplay,
          pauseOnHover: this.pauseOnHover,
          spacing: this.spacing,
          breakpoints: {
            '(min-width: 901px)': {
              slidesPerView: this.slidesPerViewDesktop
            },
            '(min-width: 601px) and (max-width: 900px)': {
              slidesPerView: this.slidesPerViewTablet,
              customAnimation: false,
              mode: "free"
            },
            '(max-width: 600px)': {
              slidesPerView: this.slidesPerViewMobile,
              customAnimation: false,
              mode: "free"
            }
          }
        });
      } else {
        this.slidesWrapper.classList.add('initialized');
      }
    }

    bindCustomizerEvents() {
      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e)=>{
          let index = Array.from(this.slides).findIndex(x=>x==e.target);
          if(index>=0) {
            setTimeout(()=>{
              this.carousel.moveToSlideRelative(index, true, 0)
            }, 10);
          }
        });
      }
    }

  }

  customElements.define('featured-items', ComponentFeaturedItems);
}